import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from 'react-router';
import { useAuth } from '../api/auth/store';
import { redirectToLogin } from '../api/auth/actions';

const Login = () => {
    const navigate = useNavigate();
    const { isLogin, loading, init, isInit } = useAuth();

    useEffect(() => {
        // Check if user is already logged in
        init();
    }, [init]);

    useEffect(() => {
        // Redirect to home if already logged in
        if (isLogin && !loading) {
            navigate('/');
        }
    }, [isLogin, loading, navigate]);

    const handleLogin = () => {
        redirectToLogin();
    };
    if (loading || !isInit || isLogin) return <></>

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
            <Row>
                <Col className="text-center">
                    <h1 className="mb-4">Mobile Banking Manager</h1>
                    <p className="mb-4 text-muted">Please sign in to continue</p>
                    <Button 
                        variant="primary" 
                        size="lg" 
                        onClick={handleLogin}
                        className="px-5"
                    >
                        Sign In with CPASS
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}

export default Login;